import React from 'react'
import style from './header.module.css';


const Header = () => {
  return (
    <div className={style.headerContainer}>
        <h1>Black Money Movement</h1>
        <hr />
    </div>
  )
}

export default Header
